import { ScaledStage } from "./ScaledStage";

import type { Language } from "@marshmallow-duel/simulation";
import type { TranslationKey } from "../i18n";

export type MenuAction = "begin" | "loadPlayers" | "editPlayers" | "hall" | "editor" | "controls" | "abilities" | "settings" | "authors" | "exit";

const menuItems: readonly { readonly action: MenuAction; readonly key: TranslationKey }[] = [
  { action: "begin", key: "menu.begin" },
  { action: "loadPlayers", key: "menu.loadPlayers" },
  { action: "editPlayers", key: "menu.editPlayers" },
  { action: "hall", key: "menu.hall" },
  { action: "editor", key: "menu.editor" },
  { action: "controls", key: "menu.controls" },
  { action: "abilities", key: "menu.abilities" },
  { action: "settings", key: "menu.settings" },
  { action: "authors", key: "menu.authors" },
  { action: "exit", key: "menu.exit" }
];

interface OriginalMenuProps {
  readonly language: Language;
  readonly t: (key: TranslationKey) => string;
  readonly onAction: (action: MenuAction) => void;
  readonly onToggleLanguage: () => void;
}

export const OriginalMenu = ({ language, t, onAction, onToggleLanguage }: OriginalMenuProps) => (
  <ScaledStage className="menu-stage">
    <img className="menu-title-image" src="/assets/original/backgrounds/bg_menu_title.png" alt="Marshmallow Duel Reloaded" />
    <nav className="original-menu" aria-label="Main menu">
      {menuItems.map(({ action, key }) => (
        <button key={action} type="button" onClick={() => onAction(action)}>
          <span className="menu-pointer" aria-hidden="true" />
          {t(key)}
        </button>
      ))}
    </nav>
    <button type="button" className="language-button" onClick={onToggleLanguage}>{language === "cz" ? "Čeština" : "English"}</button>
    <div className="menu-water" aria-hidden="true" />
  </ScaledStage>
);
